import Styled from 'styled-components';

import { FlexColumn } from '../../Common/CommonStyles';

const ApplicationCardContentLayout = Styled(FlexColumn)`
  width: 100%;
`;

export default ApplicationCardContentLayout;
